module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/ifrc-ff1abda46d546c906826874a44899124.png";